import GallectionGrid from './GallectionGrid';
export default GallectionGrid;

//# sourceMappingURL=index.js.map